import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RecordKPRConstants } from '../record-kpr-constants';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from '../../shared/constants/api-constants';
import { ChatRequestDto } from '../models/chat-request-dto';
import { ChatResponseDto } from '../models/chat-response-dto';

@Injectable({
    providedIn: 'root'
})
export class RecordKPRService {
    constructor(private httpClient: HttpClient) { }

    sendMessage(request: ChatRequestDto): Observable<string> {
        return this.httpClient.post<ChatResponseDto>(ApiConstants.RecordKPR_Chat_Api, request).pipe(
            map((resp: ChatResponseDto) => resp?.response ?? RecordKPRConstants.Agent_Busy_Message)
        );
    }

    recordKPRViewAuthorization(): Observable<boolean> {
        return this.httpClient.get<boolean>(ApiConstants.RecordKPR_View_Authorize_Api);
    }
}
